package one.healthium.insights.data.utils

import one.healthium.insights.data.dto.ActionDto
import one.healthium.insights.data.dto.ContentEntryDto

internal class CustomSerializerModules {

    val modules = listOf(
        ContentEntryDto.module,
        ActionDto.module
    )
}